module.exports = __webpack_public_path__ + "static/media/loading.b2a7acb9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 600
// module chunks = 0